<template>
    <input :class="inputClasses" :value="value" v-bind="inputAttrs" v-on="inputListeners" @focus="focus($event)" />
</template>

<script>
export default {
    name: "mds-input",
    inheritAttrs: false,
    props: {
        size: {
            type: String,
            default: "medium",
            validator: function(value) {
                return ["small", "medium", "large"].indexOf(value) !== -1;
            }
        },
        value: {
            type: [String, Number],
            default: ""
        },
        align: {
            type: String,
            default: "",
            validator: function(value) {
                return ["", "right"].indexOf(value) !== -1;
            }
        }
    },
    computed: {
        isCheckBox() {
            return this.$attrs.type === "checkbox";
        },
        isRadio() {
            return this.$attrs.type === "radio";
        },
        inputAttrs() {
            return Object.assign(
                {
                    type: "text"
                },
                this.$attrs
            );
        },
        inputListeners() {
            const vm = this;
            let overrideInputListener = {};
            if (!this.isCheckBox && !this.isRadio) {
                overrideInputListener = {
                    input: function(event) {
                        vm.$emit("input", event.target.value, event);
                    }
                };
            }
            return Object.assign({}, this.$listeners, overrideInputListener);
        },
        inputClasses() {
            return {
                [`mds-form__input--${this.size}`]: !this.isCheckBox && !this.isRadio && this.size !== "medium",
                "mds-form__input": !this.isCheckBox && !this.isRadio,
                "mds-form__input--right-aligned": this.align === "right"
            };
        }
    },
    methods: {
        focus(event) {
            event.currentTarget.select();
        }
    }
};
</script>
